import styled, { keyframes } from 'styled-components';

const modalUp = keyframes`
  0% { bottom: -100% }
  100% { bottom: 0 }
`;

export const ModalWrap = styled.section`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #000;
  display: flex;
  align-items: flex-start;
  padding: 20px;
  padding-top: 50px;
  box-sizing: border-box;
  z-index: 100;

  & > .close {
    position: absolute;
    top: 18px;
    right: 22px;
  }

  & > div {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 17px;

    & a {
      color: #fff;
      font-weight: 700;
      text-align: center;
      line-height: 25px;
    }

    & > .telm {
      margin-top: 20px;
    }

    & > div {
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;

      & > h2 {
        width: 314px;
        color: #ACAAAA;
        font-weight: 900;
        font-size: 29px;
        text-transform: uppercase;
        text-align: center;
      }
    }
  }
`;

export const ContentModal = styled.section`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.90);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 100;

  & > div {
    position: relative;
    width: 100%;
    max-width: 430px;
    height: 80%;
    background: #FFF;
    padding: 20px;
    padding-top: 17px;
    padding-bottom: 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 30px;
    animation: ${modalUp} 0.3s forwards;

    & > span {
      position: absolute;
      left: auto;
      top: -31px;
      width: 86px;
      height: 4px;
      background: #fff;
      border-radius: 50px;
    }

    & > .circleClose {
      position: absolute;
      right: 29px;
      top: -19px;
    }

    & > h3 {
      width: 171.133px;
      color: #000;
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      line-height: 24px;
    }

    & > section {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      overflow-y: auto;
      row-gap: 12px;
    }
  }
`;

export const SimpleModal = styled.section`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  background: rgba(255, 255, 255, 0.95);
  cursor: pointer;

  & > div {
    position: relative;
    width: 100%;
    max-width: 600px;
    background: #FFF;
    border: 1px solid #ddd;
    border-bottom: 2px solid #ddd;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 20px;
    animation: ${modalUp} 0.3s forwards;
    max-height: 700px;
    overflow: auto;
    @media screen and (orientation: portrait) {
      max-width: 100%;
      align-items: flex-start;
      max-height: 500px;
      border: 0;
    }
  }

  @media screen and (orientation: portrait) {
    align-items: flex-end;
  }
`;

export const Modalsubscribe = styled.div`
  width: 100%;
  padding: 20px;
  padding-top: 25px;
  padding-bottom: 25px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  row-gap: 20px;

  & > h2 {
    color: #000;
    font-size: 22px;
    font-weight: 900;
    letter-spacing: 1.92px;
    text-decoration-line: underline;
    text-transform: uppercase;
  }

  & > p {
    color: #000;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.84px;
    @media screen and (orientation: portrait) {
      font-size: 14px;
    }
  }

  & > ul {
    margin: 0;
    list-style: none;
    margin-bottom: 10px;
    padding-left: 10px;

    & > li {
      font-size: 13px;
      text-transform: uppercase;
      letter-spacing: 1px;
      cursor: pointer;
      margin-bottom: 15px;

      & > a {
        & > span {
          text-transform: none;
          font-size: 12px;
          color: #333;
          letter-spacing: 0.5px;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  & > div {
    width: 100%;
    display: flex;
    column-gap: 20px;

    & > a {
      width: 150px;
      height: 30px;
      color: #FFF;
      font-size: 12px;
      font-weight: 600;
      text-align: center;
      letter-spacing: 1.2px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #000;
      color: #fff;
    }

    & > span {
      width: 123px;
      height: 30px;
      color: #FFF;
      font-size: 12px;
      font-weight: 600;
      text-align: center;
      letter-spacing: 1.2px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #DDD;
      color: #000;
      cursor: pointer;
    }
  }
`;
